// extracted by mini-css-extract-plugin
export var discard = "_3a-3";
export var muiTooltipTooltip = "_3a-5";
export var notificationBar = "_3a-2";
export var saveButtonHoverSlotWrapper = "_3a-4";
export var show = "_3a-1";
export var spacer = "_3a-0";